import React from "react";
import styled from "styled-components";
import {useTheme} from "../../UI/Theme/ThemeContext";

const ProgressContainer = styled.div`
    width: 100%;
    height: 20px;
    background: ${({theme})=> theme === "dark" ? 'rgba(12,30,40,0.64)' : '#fff'}; /* dark background */
    border-radius: 50px;
    overflow: hidden;
    position: relative;
`;

const ProgressFill = styled.div`
    height: 100%;
    width: ${props => props.value}%;
    background: ${props =>
            props.value < 60
                    ? "linear-gradient(90deg, #ffb347, #ffcc33)" // orange gradient
                    : "linear-gradient(90deg, #38ef7d, #11998e)"}; // green gradient
    border-radius: inherit;
    transition: width 0.4s ease, background 0.4s ease;
`;

const ProgressCircle = styled.div`
    position: absolute;
    top: 50%;
    left: ${props => (props.value === 100 ? "calc(100% - 15px)" : props.value +"%")};
    transform: translate(-50%, -50%);
    background: ${props => (props.value >= 60 ? "#1e2d2f" : "#111")};
    color: ${props => (props.value >= 60 ? "#fff" : "red")};
    font-size: 12px;
    font-weight: bold;
    border-radius: 50%;
    padding: 6px;
    white-space: nowrap;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.4);
    transition: left 0.4s ease, background 0.4s ease, color 0.4s ease;
`;

const ProgressBar = ({ value }) => {
    const {themeName} = useTheme();
    return (
        <ProgressContainer theme={themeName}>
            <ProgressFill value={value} />
            <ProgressCircle value={value}>{value}%</ProgressCircle>
        </ProgressContainer>
    );
};

export default ProgressBar;